/* Daza Organic · «Cómo se usa»: un paso activo a la vez, cambia cada 5s en
   ciclo continuo (mismo criterio que «qué lleva»: hover/foco/toque pausa,
   prefers-reduced-motion lo desactiva). La foto de la izquierda
   (.s-ficha__paso-foto) sigue al paso activo: mismo índice que el <li>. */
(function () {
  'use strict';

  function definir() {
    if (customElements.get('daza-pasos-ciclo')) return;

    customElements.define('daza-pasos-ciclo', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.listo) return;
        this.dataset.listo = '1';

        var pasos = [].slice.call(this.querySelectorAll('.s-ficha__paso'));
        var fotos = [].slice.call(this.querySelectorAll('.s-ficha__paso-foto'));
        if (pasos.length < 2) return;

        var reduce = window.matchMedia('(prefers-reduced-motion:reduce)');
        var activo = 0;
        var timer = null;

        function marcar(i) {
          activo = i;
          pasos.forEach(function (li, idx) {
            li.classList.toggle('is-activa', idx === activo);
          });
          fotos.forEach(function (f, idx) {
            f.classList.toggle('is-activa', idx === activo);
          });
        }
        var el = this;
        function iniciar() {
          if (timer || reduce.matches) return;
          el.classList.remove('is-pausado');
          timer = setInterval(function () {
            marcar((activo + 1) % pasos.length);
          }, 5000);
        }
        function detener() {
          clearInterval(timer);
          timer = null;
          el.classList.add('is-pausado');
        }

        /* La foto de la derecha toma la altura de la lista de pasos (ver CSS).
           Como solo el paso activo muestra su descripción, la lista cambiaría
           de alto en cada paso y la foto «respiraría». Se mide una vez la
           altura de la lista con CADA paso activo y se fija la mayor como
           min-height: la altura queda estable. Solo en escritorio (2 columnas). */
        var lista = this.querySelector('.s-ficha__pasos');
        var ALTO_MIN = 360; // px: por debajo la foto (4:5) quedaría demasiado pequeña
        function fijarAlto() {
          if (!lista) return;
          lista.style.minHeight = '';
          el.style.removeProperty('--alto-modo');
          var dosColumnas = getComputedStyle(el).gridTemplateColumns.split(' ').length > 1;
          if (!dosColumnas) return;
          var previo = activo;
          el.classList.add('midiendo');
          var mayor = 0;
          pasos.forEach(function (li, idx) {
            marcar(idx);
            mayor = Math.max(mayor, lista.offsetHeight);
          });
          marcar(previo);
          el.classList.remove('midiendo');
          var alto = Math.max(mayor, ALTO_MIN);
          lista.style.minHeight = alto + 'px';
          el.style.setProperty('--alto-modo', alto + 'px');
        }
        fijarAlto();
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(fijarAlto);
        var redim = null;
        window.addEventListener('resize', function () {
          clearTimeout(redim);
          redim = setTimeout(fijarAlto, 150);
        });

        iniciar();

        pasos.forEach(function (li, idx) {
          li.addEventListener('mouseenter', function () { detener(); marcar(idx); });
          li.addEventListener('mouseleave', iniciar);
          li.addEventListener('click', function () { detener(); marcar(idx); });
          li.addEventListener('focusin', function () { detener(); marcar(idx); });
          li.addEventListener('focusout', iniciar);
        });
      }
    });
  }

  definir();
  document.addEventListener('shopify:section:load', definir);
})();
